export default "__VITE_ASSET__ugMM3hb9__$_?url__"